<div class="body-wrapper">
  <div>
    <vy-modal></vy-modal>
    <router-outlet></router-outlet>
    <vy-loader-full-screen></vy-loader-full-screen>
  </div>
</div>
